<template>
    <div class="yams-layout">
        <TempSideBar />
        <div id="contentys" class="content-wrapper">
            <TempNavBar></TempNavBar>
            <div v-if="withoutHeader" class="main-content">
                <slot name="content"></slot>
            </div>
            <div v-else class="main-content">
                <div class="header-contentys d-flex align-items-center">
                    <slot name="header"></slot>
                </div>
                <hr>
                <div id="page-content" class="body-contentys overflow-auto">
                    <div class="container">
                        <slot name="content"></slot>
                    </div>
                </div>
            </div>
        </div>
        <TempFooter />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import TempNavBar from '@/layouts/NavBar.vue'
import TempSideBar from '@/layouts/SideBar.vue'
import TempFooter from '@/layouts/FooterBar.vue'

export default defineComponent({
    name: 'App',
    props: ['withoutHeader'],
    components: { TempNavBar, TempSideBar, TempFooter },
    computed: {
        currentRouteName(): string {
            // Récupère le nom de la route actuelle et le formate correctement
            const routeName: string = this.$route.name?.toString() || '';
            if (!routeName) return '';

            // Transforme "nom_route" ou "nomRoute" en "Nom Route"
            return routeName
                .replace(/_/g, ' ')  // Remplace les underscores par des espaces
                .replace(/([A-Z])/g, ' $1')  // Ajoute un espace avant chaque majuscule
                .replace(/^\s+/, '')  // Enlève l'espace au début s'il y en a un
                .split(' ')  // Divise en mots
                .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())  // Capitalise chaque mot
                .join(' ');  // Rejoint les mots avec des espaces
        }
    }
})
</script>

<style scoped>
.yams-layout {
    display: flex;
    width: 100%;
    min-height: 100vh;
}

.content-wrapper {
    flex: 1;
    margin-left: 70px;
    /* Largeur de la sidebar */
    width: calc(100% - 70px);
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.main-content {
    flex: 1;
    padding: 15px;
    overflow: auto;
}

#page-content {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-clip: border-box;
    flex: 1 1 auto;
    min-height: 1px;
    height: calc(100vh - 180px) !important;
    /* Ajustement pour laisser de l'espace pour la navbar et le footer */
    overflow-x: hidden !important;
}

@media (max-width: 992px) {
    .content-wrapper {
        margin-left: 0;
        width: 100%;
    }
}
</style>